import { defaultErrorField } from "../constants/validationErrors";

export const useFormValidation = () => {
    const validateForm = ({ quoteImage, articleImage, formData, isUpdating }) => {
        const errors = [];
        const { article } = formData;
        if (!isUpdating) {
            if (!quoteImage) {
                errors.push({ input: "imageUrl", message: defaultErrorField.imageUrl }); 
            }
        }
        
        const isEmpty = Object.values(article).every (
            (val) => { 
                if (Array.isArray(val)) {
                    return val.length === 0;
                }
                return (val === "" || val === null) && articleImage === null;
            }
        );

        if (!isEmpty) {
            const title = article.title?.trim() ?? "";
            const body = article.articleHtml?.trim() ?? "";
            const hasImage = !!(articleImage || article.imageUrl);

            if (hasImage) {
                if (title === "") {
                    errors.push({ input: "articleTitle", message: defaultErrorField.articleTitle });
                }
                if (body === "") {
                    errors.push({ input: "articleBody", message: defaultErrorField.articleBody });
                }
            }
            if (!hasImage && (!title || !body)) {
                if (!title) {
                    errors.push({ input: "articleTitle", message: defaultErrorField.articleTitle });
                }
                if (!body) {
                    errors.push({ input: "articleBody", message: defaultErrorField.articleBody });
                }
            }
        }

        return errors;
    };

    return { validateForm };
};
